'use client'

import { Icon } from '@circlefin/components/lib/Icon'

export const CWIcon = Icon
export const CWIconCircle = Icon.Circle
